import { useCallback, useState } from "react";

export function useImageValidation() {
  const [validationErrors, setValidationErrors] = useState([]);

  const checkImageResolution = useCallback((file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const resolution = img.naturalWidth * img.naturalHeight;
        const maxResolution = 25 * 1_000_000; // 25 megapixels
        URL.revokeObjectURL(img.src);
        resolve({ file, rejected: resolution > maxResolution });
      };
      img.onerror = () => {
        URL.revokeObjectURL(img.src);
        reject(new Error("Bildladdning misslyckades"));
      };
      img.src = URL.createObjectURL(file);
    });
  }, []);

  const validateFiles = useCallback(
    async (files) => {
      const rejectedImages = [];
      const maxFileSize = 10 * 1024 * 1024; // 10MB
      const errors = [];

      for (const file of files) {
        const fileErrors = [];
        let shouldReject = false;

        // Kontrollera filstorlek först
        if (file.size > maxFileSize) {
          fileErrors.push("För stor fil (max 10MB)");
          shouldReject = true;
        }

        // Kontrollera upplösning även om filen är för stor
        try {
          const result = await checkImageResolution(file);
          if (result.rejected) {
            fileErrors.push("För hög upplösning (max 25MP)");
            shouldReject = true;
          }
        } catch (error) {
          console.warn("Bildvalidering misslyckades för:", file.name, error);
          fileErrors.push("Kunde inte läsas");
          shouldReject = true;
        }

        // Lägg till fil i rejected och skapa sammanslaget felmeddelande
        if (shouldReject) {
          rejectedImages.push(file);
          errors.push(`${file.name}: ${fileErrors.join(" och ")}`);
        }
      }

      setValidationErrors(errors);
      return { rejectedImages, errors };
    },
    [checkImageResolution]
  );

  const clearValidationErrors = useCallback(() => {
    setValidationErrors([]);
  }, []);

  return {
    validateFiles,
    checkImageResolution,
    validationErrors,
    clearValidationErrors,
  };
}
